const VNodes = (props) => {
  return props.vnodes
}

VNodes.props = ['vnodes']

export default VNodes
